export default [
  {
    id: 1,
    type: 'bridal',
    image: '/redlane-spa/weddings/hairdressers.jpg',
    title: 'Something Loved',
    list: [
      'Trial Hair & Make-up Session',
      'Hair & Make-up on your Big Day'
    ],
    price: 315
  },
  {
    id: 2,
    type: 'bridal',
    image: '/redlane-spa/weddings/bride.jpg',
    title: 'Something New',
    list: [
      'Trial Hair & Make-up Session',
      'Hair & Make-up on your Big Day',
      'Simply you Manicure & Pedicure'
    ],
    price: 405
  },
  {
    id: 3,
    type: 'bridal',
    image: '/redlane-spa/weddings/coconuts.jpg',
    title: 'Something Borrowed',
    list: [
      'Trial Hair & Make-up Session',
      'Hair & Make-up on your Big Day',
      'Sugarcane Warm Oil Scrub'
    ],
    price: 467
  },
  {
    id: 4,
    type: 'bridal',
    image: '/redlane-spa/weddings/girl-in-blue.jpg',
    title: 'Something Blue',
    list: [
      'Trial Hair & Make-up Session',
      'Hair & Make-up on your Big Day',
      'Bridal Radiance Facial'
    ],
    price: 495
  },
  {
    id: 5,
    type: 'bridal',
    image: '/redlane-spa/weddings/spa-treatments.jpg',
    title: 'Exuberant Bride',
    list: [
      'Trial Hair & Make-up Session',
      'Hair & Make-up on your Big Day',
      'Bridal Radiance Facial',
      'Firm & Glow Eye Treatment',
      'Caribbean Glow Body Treatment'
    ],
    price: 405
  },
  {
    id: 6,
    type: 'bridalParty',
    image: '/redlane-spa/weddings/dinner-hair.jpg',
    title: 'Primp and Powder',
    subTitle: 'Rehearsal Dinner Hair & Make-up',
    description: 'Your Sandals Wedding experience isn\'t just about looking beautiful when you walk down the aisle. It\'s about your wedding party looking great at the Rehearsal Dinner before the ceremony. Let our experts primp and powder your bridal party for this integral part of the experience.',
    price: 186
  },
  {
    id: 7,
    type: 'bridalParty',
    image: '/redlane-spa/weddings/manicures.jpg',
    title: 'Fingers to your Toes',
    subTitle: 'Manicures & Pedicures',
    description: 'Make sure everyone in your bridal party feels great from their fingers to their toes! Our manicures and pedicures begin with thirst-quenching soaks and cocktail-inspired exfoliating scrubs followed by a hydrating massage and polish change with the lacquer of your choice.',
    price: 113
  },
  {
    id: 8,
    type: 'bridalParty',
    image: '/redlane-spa/weddings/tennis.jpg',
    title: 'Tennis Round Robin Tournament',
    subTitle: 'Tennis for Beginners & Advanced Players',
    description: 'It\'s time for a little healthy competition between the boys and girls in your WeddingMoon® party. Whether you are a beginner or advanced player, this is a great way to build cherished memories on your Caribbean wedding holiday.',
    price: 68
  },
  {
    id: 8,
    type: 'bridalParty',
    image: '/redlane-spa/weddings/coctails.jpg',
    title: 'Wedding O’Clock-tails',
    description: 'Spoil your bridal party with cocktail-inspired mini treatments and tropical drinks. Experience exfoliating hand and foot scrubs, and relaxing mini massages in the following scents: Watermelon Cucumber Cooler, Gingerita, Rum Punch, Whoopie Cream & Hot Whiskey Sour.',
    price: 90
  },
  {
    id: 9,
    type: 'grooms',
    image: '/redlane-spa/weddings/guys.jpg',
    title: 'Gentleman’s Hot Whiskey Sour',
    description: 'The groom and his best pals enjoy an express manicure and pedicure with a brown sugar whiskey exfoliation, followed by a hydrating white velvet buttercream-scented shea butter application, and light refreshments and cocktails.',
    price: 70
  },
  {
    id: 10,
    type: 'grooms',
    image: '/redlane-spa/weddings/mans-treatment.jpg',
    title: 'For Him Facial',
    description: 'Renew your skin with this exclusive treatment for men. Our deep cleanse, exfoliation and mask help remove buildup caused by environmental exposure. This therapeutic treatment designed to improve elasticity and fight the early signs of aging, leaves your skin feeling younger and firmer.',
    price: 152
  },
  {
    id: 11,
    type: 'grooms',
    image: '/redlane-spa/weddings/groom.jpg',
    title: 'Groom Me',
    list: [
      'Hair cut',
      'Hue-Man Manicure'
    ],
    price: 66
  },
  {
    id: 12,
    type: 'grooms',
    image: '/redlane-spa/weddings/massage-tables.jpg',
    title: 'Man Up',
    list: [
      'Deep Relief Massage (50 min)',
      'For Him Facial',
      'Hue-Man Manicure'
    ],
    price: 258
  }
];
